import {Client} from "./client.model";
import {VImage} from "./vet-clinic.model";

/**
 * Model reprezentujący Partnera Biznesowego.
 * Rozszerza klasę `Client`, dodając do niej funkcje marketingowe, brandingowe
 * oraz obsługę programu afiliacyjnego (Ambassador).
 */
export class Partner extends Client {

  /** Flaga określająca, czy profil partnera jest aktywny i widoczny w systemie. */
  public active: boolean;

  /** Obraz wyświetlany na ekranie powitalnym (Splash Screen) aplikacji mobilnej. */
  public splashScreenImage: VImage;
  public splashScreenImageUUID: string;

  /** Logotyp partnera. */
  public logoImage: VImage;
  public logoImageUUID: string;

  /** Główny obraz/zdjęcie w tle na dedykowanej stronie partnera w aplikacji. */
  public partnerPageImage: VImage;
  public partnerPageImageUUID: string;


  /** Zakładka/Ekran w aplikacji, na którym ma wyświetlać się Baner 1 (np. 'home-tab'). */
  public banner1Page: string;
  /** Placeholder przeznaczony na Baner 1. */
  public banner1Placeholder: string;
  public banner1ImageUUID: string;
  public banner1Image: VImage;

  public banner2Page: string;
  public banner2Placeholder: string;
  public banner2ImageUUID: string;
  public banner2Image: VImage;

  public banner3Page: string;
  public banner3Placeholder: string;
  public banner3ImageUUID: string;
  public banner3Image: VImage;

  /** Baner wyświetlany po udanej akcji. */
  public successActionBannerImageUUID: string;
  public successActionBannerImage: VImage;

  public additionalImage1ImageUUID: string;
  public additionalImage1Image: VImage;

  public additionalImage2ImageUUID: string;
  public additionalImage2Image: VImage;

  public additionalImage3ImageUUID: string;
  public additionalImage3Image: VImage;

  public additionalImage4ImageUUID: string;
  public additionalImage4Image: VImage;


  /** Nagłówek/Tytuł na dedykowanej stronie partnera w aplikacji. */
  public appPartnerPageTitle: string;
  /** Slogan reklamowy partnera. */
  public appPartnerPageSlogan: string;
  /** Główny tekst/opis działalności partnera. */
  public appPartnerPageContent: string;

  /** Treść własnego regulaminu usług partnera. */
  public termsOfServicePageContent: string;

  /** Czy partner może publikować własne artykuły. */
  public isArticleModeEnabled: boolean;

  /** Czy system ma globalnie walidować NIP tego partnera. */
  public isNipGlobalValidationNecessary: boolean;

  /** Czy banery partnera są klikalne (przekierowują do akcji/linków). */
  public partnerBannerActions: boolean;

  /** Unikalny kod polecający partnera. */
  public ambassadorCode: string;

  /** Wartość zniżki, jaką otrzymuje klinika (Lead), która zarejestruje się z kodem tego partnera. */
  public leadDiscount: number;
  /** Przez ile miesięcy nowa klinika cieszy się zniżką na abonament. */
  public leadDiscountMonths: number;

  /** Prowizja dla partnera za skuteczne polecenie systemu nowej klinice. */
  public ambassadorFee: number;
  /** Przez ile miesięcy partner otrzymuje prowizję od poleconej kliniki. */
  public ambassadorDiscountMonths: number;

  /** Czy partner bierze udział w programie kodów promocyjnych. */
  public promotionalCodeProgram: boolean;

  /** Czy moduł sklepu zewnętrznego jest włączony dla tego partnera. */
  public shopModuleEnabled: boolean;

  /** Treść regulaminu/zgody na przekazanie danych pacjenta, wyświetlana przed przekierowaniem do sklepu partnera. */
  public shopRedirectionTerms: string;

  /** Opis informujący pacjenta, na jakich zasadach jest przekierowywany. */
  public shopRedirectionTermsDescription: string;

  constructor() {
    super()
  }
}
